import {createFileRoute, notFound} from "@tanstack/react-router";
import {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import {buildWorkspaceDefinitionMetadataLookups} from "~/domainModels/adminModels/workspaceDefinitionMetadata";
import {getWorkspaceDefinitionsMetadataWithCaching} from "~/utilities/fetchWorkspaceDefinitionsMetadata";
import {getAdminWorkspacesWithCaching} from "../../workspace/-queries";
import {ErrorComponent} from "../-errorComponent";
import {NotFoundComponent} from "../-notFoundComponent";
import {PendingComponent} from "../-pendingComponent";
import {getWorkspaceCapabilitiesByTypeWithCaching} from "../-queries";
import {RouteComponent} from "./-routeComponent";

const workspaceCapabilityTypeValues = new Set<string>(Object.values(WorkspaceCapabilityType));

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/workspace-capabilities/$capabilityType",
)({
    loader: async ({context, params}) => {
        if (workspaceCapabilityTypeValues.has(params.capabilityType) !== true) {
            throw notFound();
        }
        const capabilityType = params.capabilityType as WorkspaceCapabilityType;

        const [workspaceDefinitionsMetadata, workspaces, capabilityRows] = await Promise.all([
            getWorkspaceDefinitionsMetadataWithCaching({
                queryClient: context.queryClient,
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
            }),
            getAdminWorkspacesWithCaching({
                queryClient: context.queryClient,
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
            }),
            getWorkspaceCapabilitiesByTypeWithCaching({
                queryClient: context.queryClient,
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
                type: capabilityType,
            }),
        ]);

        const {capabilityByType} = buildWorkspaceDefinitionMetadataLookups(workspaceDefinitionsMetadata);
        const capabilityDefinition = capabilityByType.get(capabilityType);
        if (capabilityDefinition === undefined) {
            throw notFound();
        }

        return {
            capabilityType,
            capabilityDefinition,
            workspaceDefinitionsMetadata,
            workspaces,
            capabilityRows,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
